import Vue from "vue";
export default {
  namespaced: true,
  state: {
    eventsList: [],
    hasMorePages: false,
    featuredEvent: {},
    filters: [],
    specificEvent: {
      sponsors: [],
    },
    associatedExhibition: {},
    timeslotDatesAvailability: [],
    timeslotAvailability: [],
  },
  getters: {
    getEventsList(state) {
      return state.eventsList;
    },
    getSpecificEvent(state) {
      return state.specificEvent;
    },
    getAssociatedExhibition(state) {
      return state.associatedExhibition;
    },
    getHasMorePages(state) {
      return state.hasMorePages;
    },
    getFeaturedEvent(state) {
      return state.featuredEvent;
    },
    getFilters(state) {
      return state.filters;
    },
    getTimeslotAvailability(state) {
      return state.timeslotAvailability;
    },
    getTimeslotDatesAvailability(state) {
      return state.timeslotDatesAvailability;
    },
  },
  mutations: {
    setEventsList(state, { data, page }) {
      if (page > 1) {
        state.eventsList = state.eventsList.concat(data);
      } else {
        state.eventsList = data;
      }
    },
    setSpecificEvent(state, payload) {
      state.specificEvent = payload;
    },
    setAssociatedExhibition(state, payload) {
      state.associatedExhibition = payload;
    },
    setHasMorePages(state, payload) {
      state.hasMorePages = payload;
    },
    setFeaturedEvent(state, payload) {
      state.featuredEvent = payload;
    },
    setFilters(state, payload) {
      let filters = [
        {
          key: "",
          title: "ALL EVENTS",
          selected: true,
        },
      ];
      payload.forEach(el => {
        filters.push({ ...el, selected: el.selected ? el.selected : false });
      });
      state.filters = filters;
    },
    changeFilterValue(state, payload) {
      let filters = state.filters;
      filters.forEach(el => {
        el.selected = el.key === payload.key ? true : false;
      });
      state.filters = filters;
    },
    setTimeslotAvailability(state, payload) {
      state.timeslotAvailability = payload;
    },
    setTimeslotDatesAvailability(state, payload) {
      state.timeslotDatesAvailability =
        payload?.map(el => {
          return { title: el.value, id: el.key };
        }) || [];
    },
  },
  actions: {
    async apiGetEventsList({ commit }, { sort = "", page = "1", events = "" }) {
      let query = {
        sort,
        page,
        events,
      };
      let queryStr = "";
      let success = false;
      for (let key in query) {
        if (query[key]) {
          queryStr += `${key}=${query[key]}&`;
        }
      }
      await Vue.axios.get(`/api/public/events/list?${queryStr}`).then(response => {
        success = true;
        commit("setEventsList", { data: response.data.response, page });
        commit("setHasMorePages", response?.data?.hasMorePages);
      });
      return success;
    },

    async apiGetFeaturedEvent({ commit }) {
      await Vue.axios
        .get("/api/public/featured-event")
        .then(res => res.data)
        .then(data => {
          commit("setFeaturedEvent", data?.response);
        });
    },

    async apiGetFiltersBlock({ commit }, { list, type }) {
      await Vue.axios
        .get(`/api/public/filters?list=${list}&type=${type}`)
        .then(res => res.data)
        .then(data => {
          commit("setFilters", data?.response[0]?.items);
        });
    },

    async apiGetSpecificEvent({ commit }, slug) {
      await Vue.axios.get(`/api/public/events/${slug}`).then(response => {
        const mockEvent = {
          ...response?.data?.response.event,
          sponsors: response?.data?.response.event.sponsors
            ? response?.data?.response.event.sponsors
            : [],
          slug,
        };
        commit("setSpecificEvent", mockEvent ?? {});
        commit("setAssociatedExhibition", response?.data?.response.exhibition ?? {});
      });
    },

    async apiGetEventTimeslotAvailability({ commit }, { id, date }) {
      let result = false;
      await Vue.axios
        .get(`/api/public/event/timeslot-times?event_id=${id}&date=${date}`)
        .then(res => res.data)
        .then(data => {
          result = true;
          commit("setTimeslotAvailability", data.response);
        });
      return result;
    },
    async apiGetEventTimeslotDaysAvailability({ commit }, id) {
      let result = false;
      await Vue.axios
        .get(`/api/public/event/timeslot-dates?event_id=${id}`)
        .then(res => res.data)
        .then(data => {
          result = true;
          commit("setTimeslotDatesAvailability", data.response);
        });
      return result;
    },

    async apiPostEventRsvp({}, { event_slug, data }) {
      let result = { success: false, error: null };
      await Vue.axios
        .post(`/api/public/event/${event_slug}/rsvp`, data)
        .then(() => {
          result = { success: true, error: null };
        })
        .catch(e => {
          let response = e.response;
          if (response.status === 422) {
            result = { success: false, error: response.data.detail };
          }
        });
      return result;
    },
  },
};

